import {dynamic} from '@github-ui/dynamic'

import type {NavigationTabPopoverProps} from './NavigationTabPopover'

const NavigationTabPopover = dynamic(
  async () => {
    const module = await import('./NavigationTabPopover')
    return {default: module.NavigationTabPopover}
  },
  {ssr: false},
)

export function LazyNavigationTabPopover(props: NavigationTabPopoverProps) {
  return <NavigationTabPopover {...props} />
}
